import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Alert, Button, Checkbox, Spin } from "antd";
import { useEffect, useState } from "react";
import { useReactMediaRecorder } from "react-media-recorder";
import { __ } from "../../utils/i18n.js";
const ALERT_STYLE = {
    margin: "10px 0"
};
const SupportFormScreenRecordingFormInput = (param)=>{
    let { value, onChange } = param;
    var _window_navigator_mediaDevices;
    const supportsScreenRecording = !!window.MediaRecorder && !!((_window_navigator_mediaDevices = window.navigator.mediaDevices) == null ? void 0 : _window_navigator_mediaDevices.getDisplayMedia);
    if (!supportsScreenRecording) {
        return /*#__PURE__*/ _jsx(Alert, {
            message: __("Your browser does not support this."),
            type: "info"
        });
    }
    const [withMicrophone, setWithMicrophone] = useState(true);
    // We need to maintain an own state for the blobs as we need the Blob instance itself
    const [file, setFile] = useState(value);
    const [fileUrl, setFileUrl] = useState();
    useEffect(()=>{
        setFileUrl(file ? URL.createObjectURL(file) : undefined);
    }, [
        file
    ]);
    const { status, previewStream, startRecording, stopRecording, error } = useReactMediaRecorder({
        screen: true,
        audio: withMicrophone,
        onStop: function(_, blob) {
            setFile(new File([
                blob
            ], "screen-recording.mp4", {
                type: "video/mp4"
            }));
        }
    });
    // Listen to manually abortion (https://stackoverflow.com/a/25179198/5506547)
    useEffect(()=>{
        var _previewStream_getVideoTracks;
        previewStream == null ? void 0 : (_previewStream_getVideoTracks = previewStream.getVideoTracks()) == null ? void 0 : _previewStream_getVideoTracks[0].addEventListener("ended", stopRecording);
    }, [
        previewStream,
        stopRecording
    ]);
    // Permission for microphone was denied, we need to show a warning to the user and stop the recording
    useEffect(()=>{
        if (status === "idle" && error === "permission_denied") {
            stopRecording();
            setFile(undefined);
        }
    }, [
        status,
        error,
        stopRecording
    ]);
    // Report back to form
    useEffect(()=>{
        onChange(file);
    }, [
        file,
        onChange
    ]);
    // Status handlings
    switch(status){
        // "media_aborted" | "permission_denied" | "no_specified_media_found" | "media_in_use" |
        // "invalid_media_constraints" | "no_constraints" | "recorder_error" | "idle" | "acquiring_media" |
        // "delayed_start" | "recording" | "stopping" | "stopped" | "paused"
        case "media_aborted":
            break;
        case "permission_denied":
            return /*#__PURE__*/ _jsx(Alert, {
                style: ALERT_STYLE,
                message: __("You did not gave permission to allow this."),
                type: "error"
            });
        // case "no_specified_media_found": (https://github.com/0x006F/react-media-recorder/issues/49)
        case "media_in_use":
            return /*#__PURE__*/ _jsx(Alert, {
                style: ALERT_STYLE,
                message: __("Currently another process is capturing your screen."),
                type: "error"
            });
        case "invalid_media_constraints":
        case "no_constraints":
        case "recorder_error":
            return /*#__PURE__*/ _jsx(Alert, {
                style: ALERT_STYLE,
                message: __("An unknown error occured: %s. Please submit the ticket without a screen recording.", status),
                type: "error"
            });
        case "idle":
        case "stopped":
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: startRecording,
                        children: status === "stopped" ? __("Restart recording") : __("Start recording")
                    }),
                    !!fileUrl && /*#__PURE__*/ _jsxs(_Fragment, {
                        children: [
                            "\xa0",
                            /*#__PURE__*/ _jsx(Button, {
                                onClick: ()=>setFile(undefined),
                                children: __("Discard video")
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx("br", {}),
                    /*#__PURE__*/ _jsx(Checkbox, {
                        checked: withMicrophone,
                        onChange: ()=>setWithMicrophone(!withMicrophone),
                        style: {
                            marginTop: 10
                        },
                        children: __("Enable microphone")
                    }),
                    error === "permission_denied" && withMicrophone && /*#__PURE__*/ _jsx(Alert, {
                        style: ALERT_STYLE,
                        message: __("You did not grant permission to use the microphone, which caused the screen recording to be cancelled. Please enable microphone access in your browser settings, or you can choose to continue without using the microphone. Once you've made your choice, you can start the recording again."),
                        type: "error"
                    }),
                    !!fileUrl && /*#__PURE__*/ _jsx("video", {
                        src: fileUrl,
                        controls: true,
                        style: {
                            width: "100%",
                            marginTop: 10
                        }
                    })
                ]
            });
        case "acquiring_media":
            return /*#__PURE__*/ _jsx(Alert, {
                style: ALERT_STYLE,
                message: __("Please select the screen or browser tab where you can reproduce the issue..."),
                type: "info"
            });
        // case "delayed_start": // Nothing to do
        case "recording":
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(Button, {
                        onClick: stopRecording,
                        children: __("Stop recording")
                    }),
                    /*#__PURE__*/ _jsx(Alert, {
                        style: ALERT_STYLE,
                        message: __('Please navigate to your WordPress tab and reproduce the issue! Afterwards finish the screen recording with "Stop recording".'),
                        type: "info"
                    })
                ]
            });
        case "stopping":
            return /*#__PURE__*/ _jsx(Spin, {});
        // case "paused": // We do not provide a pause button atm
        default:
            break;
    }
    return null;
};
export { SupportFormScreenRecordingFormInput };
